<script lang="ts">
/* 
For showing a list of the entires, for the different categories
Should get the date range, and mayeb the category type later, to decide how to show the entires. 

Steps:
#1 Show all entires as a list
#2 Show entires, with headers for the category they are in
#3 show entires for the current day, with option to change day
#4 Show entires, with the ability to show a date range (and probably have additional info/ date of each entry next to it)
*/

import { isProxy, toRaw } from 'vue';
import type CategoryData from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent } from 'vue'
import Category from './Category.vue';
import App from '../App.vue';
import StaticVars, { ModalInfo } from '@/ts/StaticVars';
import Button from "./Button.vue";
import EntryEl from "./EntryEl.vue";
import Entry from "../ts/DataTypes/Entry"
import { UserDB, type EntryAttributeDB } from '@/ts/DexieDB';
import DatePicker from './DatePicker.vue';

import { UserPrefs } from '@/ts/UserPrefs';
import InputTextSmart from './InputTextSmart.vue';


export default defineComponent({

    components: { Button, EntryEl, DatePicker },
    props:
    {
        ShowModal:{ type:Function, default:(val:ModalInfo)=>{console.log("it didn't pass ShowModal correctly");}},//have to give it a default value, or typescript thinks it could be undefined...
        // user:{type:UserDB, required:true},

        // SwitchScreen: { type: Function, default: () => { console.log("it didn't pass func correctly"); } },
        BackButtonRegister: { type: Function, required:true },
        MoveForwardToPage: { type: Function, required:true },
        MoveBack: { type: Function, required:true },// switch screen, but just for moving back

        GetEntriesByDateRange: { type: Function, required:true },
        categories: {type: Array<CategoryData>, required:true},
        DeleteEntryClicked: { type: Function, required:true },

        GetPrevEntriesForCat:{ type:Function, required:true},
        GetPrevAttributesForCat:{ type:Function, required:true},
        AddOrEditEntry:{ type:Function, required:true},
        AttributeCreateUpdateOrDelete:{ type:Function, required:true},

        //moving entry and attribute info into the app to handle local changes
        entries:{ type:Array<Entry>, required:true},
        cats_w_entries:{ type:Array<CategoryData>, required:true},
        GetEntriesInCatsByDateRange:{ type:Function, required:true},
        SetupCats:{ type:Function, required:true},
        ReloadPage:{ type:Function, required:true},
		GetEntriesBySearch:{ type:Function, required:true},
    },
    data() {
        return {
            /*
        If we refer to the data objects in the HTML area- 
        it doesn't actually grab them when they change. 
        It only gets their initial value, and doesn't update the UI, even when forced with the new value.

        So have to get their value through a "Getter", to actually get their value. Might have to put it in computed if it keeps trying to refuse to update UI
        */

        date_start:new Date(),
        date_end:new Date(),
        // icon:{ type:String, default:"home"},
        // text:{ type:String, default:"Go Home"}
        
        // cats_open: new Array<Boolean>(), //for keeping track of which cats are open, but not having to add them onto a cat

        dont_render_entries:false, //for testing/ changing entries format
        loaded:false,
        custom_date_range:false,
        key_to_force_update:0,
        entry_vue:undefined, //for which element is open
        option_date_selected:"custom", // for having a value selected in the drop down for if doing today, yesterday, custom, last week, etc,
        // entries:new Array<Entry>(),
        // cats_w_entries:new Array<CategoryData>(),
		search_txt:"",

        };
    },
    async mounted()
    {
        
        console.log("Entrylist mounted!");;

        //for testing the function
        // (window as any).ScrollToEntryByID= this.ScrollToEntryByID;
        //get the categories, then the entries
        

        
        
        
        // console.log("EntryList, got data for categories: ", cats);
        


        // console.log("EntryList - going to get entries for date range from database");
        this.date_start= new Date(); 
        this.date_start.setFullYear(new Date().getFullYear());
        this.date_start.setMonth(new Date().getMonth()-100);

        this.date_start= new Date(this.date_start); 
        // console.log("this.date_start : ", this.date_start);
        
        

        this.date_end= new Date(); 
        this.date_end.setFullYear(new Date().getFullYear()+10);


        //set the date range selected from user prefs: 
        this.option_date_selected = UserPrefs.date_range_entries.value;
        this.DateSelectChanged(this.option_date_selected);
        console.log("EntryList Loaded from UserPrefs, with option date_selected = ", this.option_date_selected);


        // console.log("waiting on user set");
        // await this.UserSet();
        await this.GetEntriesInCatsByDateRange(this.date_start, this.date_end);
        
        // console.log("finished waiting on user set");


        
        
        
        


        // this.categories.forEach((cat)=>{


        //     // console.log("EntryList going through categories for entries, this: ", this, "this.categories: ", this.categories);
        //     if(cat.entries.length>0)
        //     {

        //         cat.entries.forEach((entry)=>
        //         {
        //             this.entries.push(entry);

        //         });
        //     }
        // });

        

        //hack to try to get vue to update the children when the parent creates it props
        this.loaded=true;

        // this.$nextTick(() => 
        // {
        //   //also set this to custom for the selected date for now, since that what it defaults to with the date range set currnetly (before we start sacing out to local storage for user prefs)
        // console.log("date slected value: ", (this.$refs.date_select as HTMLSelectElement).value);
        // (this.$refs.date_select as HTMLSelectElement).value = "custom";
        // console.log("date slected value: ", (this.$refs.date_select as HTMLSelectElement).value);
        // });
    },

    
    methods:
    {
        // for if a user is set/ changed, grab the stuff that depends ont he user
        /* async GetEntriesInCatsByDateRange()
        {
        //     /console.log("GetEntriesInCatsByDateRange: starting promise");
        //     let self=this;
        //     let promise = new Promise(async function(resolve, reject) {
        //     // the function is executed automatically when the promise is constructed
          
        //     // after 1 second signal that the job is done with the result "done"
        //     // setTimeout(() => {console.log("GetEntriesInCatsByDateRange promise: actually finished", );resolve("done")}, 2000);

        //     self.entries = await (self.GetEntriesByDateRange(self.date_start, self.date_end) as Promise<Entry[]>);
        //         resolve("done")
        //   });
        //     await promise;
        //     console.log("GetEntriesInCatsByDateRange: after promise"); 

            console.log("GetEntriesInCatsByDateRange1: ");
            this.entries = await this.GetEntriesByDateRange(this.date_start, this.date_end);


            this.SetupCats()
            
        }, */
        
        /* async UserSet()
        {
            console.log("EntryList, UserSet ");
            // await Data.GetCategories(this.user.id, true) as Array<CategoryData>;
            
            console.log("EntryList, UserSet: GetEntriesByDateRange", this.date_start, this.date_end);

            // this.entries = await this.GetEntriesByDateRange(this.date_start, this.date_end);
            await this.GetEntriesInCatsByDateRange();
            
            
            //have to set this afterwards
            // this.categories = cats;

            //lets also add a "is_open prop for closing a cat
            // this.categories = cats.map((cat)=>{(cat as any).is_open=true;return cat});
            
            // console.log("EntryList finished! this.categories: ", this.categories);
            // this.$forceUpdate();
            this.ForceUpdate();
            console.log("EntryList: GetEntriesByDateRange", this.entries, "this cats: ", this.categories);
            
        }, */
        /* async DeleteClicked(extra_info:Object)
        {
            console.log("delete clicked2, id: ", extra_info);
            console.log("DeleteClicked, data.cats: ", Data.cats, "this cats: ", this.categories);
            console.log("this.ShowModal ", this.ShowModal);
            //(text:string, callback_yes?:Function, callback_no?:Function)
            let modal_info = new ModalInfo({text: "Are you sure your want to delete this entry?", callback_yes: async ()=>{console.log("yes clickedDD");await this.DeleteEntry(extra_info)}, callback_no:()=>{console.log("no clickedDD")}});
            this.ShowModal(modal_info);
            //so now have to pop up the modal 
        },
        async DeleteEntry(extra_info:any)
        {
            console.log("Delete Entry extra info: ", extra_info);
            console.log("deleting entry b4", this.categories[extra_info.cat_index].entries.length);//[extra_info.entry_index]);

            extra_info.predelete();
            

            console.error("Should not do Data.deleteentry- need to call it in parent/ pass a function from app to this to then actually delete");
            await Data.DeleteEntry(extra_info);

            //this updates, but has the error with opening up the item below the item that was deleted
            // this.categories[extra_info.cat_index].entries.splice(extra_info.entry_index, 1);

            //nothing I do allows it to update, and not push the editing flag onto the next element- seems it copies any data set on the deleted element to the next one, oddly enough
            //going to just try setting it to not editing to hide it hopefully?
            // this.$forceUpdate();
            this.ForceUpdate();

            // let new_array = [...this.categories[extra_info.cat_index].entries];
            // new_array.splice(extra_info.entry_index, 1);
            
            // this.categories[extra_info.cat_index].entries = new_array;
            

            //HACK to force it- since it's not aware of the entires inside of categories
            //from: https://stackoverflow.com/questions/32106155/can-you-force-vue-js-to-reload-re-render
            // this.$forceUpdate();
            // let temp = this.categories.entries;
            // let value = await Data.GetCategories() as Array<CategoryData>;
            // console.log("EntryList, got data for categories: ", value);
            // this.categories[extra_info.cat_index].entries = [];//does actually update

            //resets this UI and clears it out of the database
            //- so likely using splice modifys the current array, but needs to copy it, and re-assign it for vue to be aware of it
            // this.categories[extra_info.cat_index].entries = [];
            console.log("removed entries from this version, checking if removed from data: ", (await Data.cats as Array<CategoryData>)[extra_info.cat_index].entries)
            

            console.log("deleting entry after", this.categories[extra_info.cat_index].entries.length);//[extra_info.entry_index]);


            console.log("done forcing update!");
        }, */
        /* async SetupCats()
        {
            //now add them to this cats
            this.cats_w_entries = this.categories.map((cat)=>{
                let new_cat = new CategoryData(cat);
                (new_cat as any).is_open=true;
                return new_cat;
            });

            // this.cats_w_entries = this.cats_w_entries.map((cat)=>{(cat as any).is_open=true;return cat});

            console.log("GetEntriesInCatsByDateRange2: entries:", this.entries, "cats_w_entries: ",this.cats_w_entries);
            this.entries.forEach((entry)=>{

                let cat_index=-1;
               
                for (let i=0;i<this.categories.length;i++)
                {
                    let cat=this.categories[i];
                
                    if(cat.id==entry.id_cat)
                    {
                        cat_index=i;
                        break;
                    }
                }
                
                if(cat_index!=-1)
                    this.cats_w_entries[cat_index].entries.push(entry);

            });
        }, */
        async EntryEdited(extra_info:Object)
        {
            console.log("editing entry", extra_info);
            //right now just changing the name
            
            // await Data.UpdateEntry(extra_info);
            await this.AddOrEditEntry(extra_info);

            //HACK to force it- since it's not aware of the entries inside of categories
            //from: https://stackoverflow.com/questions/32106155/can-you-force-vue-js-to-reload-re-render
            // this.$forceUpdate();

            
            // this.ForceUpdate();
        },
        EntryOpened(entry_vue:typeof EntryEl)
        {
            if(this.entry_vue)
                if(this.entry_vue != entry_vue)
                    (this.entry_vue as any).Close(false);
            
            (this.entry_vue as any)=entry_vue;
            
        },
        /**
         * For App to close when enter new entry is clicked
         */
        CloseOpenEntry()
        {
            if(this.entry_vue)
                (this.entry_vue as any).Close(false);
        },
        ScrollToEntryByID(entry_id:string)
        {
            console.log("ScrollToEntryByID: ", entry_id);
            //go through the entries to find the right id
            (this.$refs.entries as Array<typeof EntryEl>).forEach(element => {
                // console.log("ScrollToEntryByID: ", element.entry);
                if(element.entry.id==entry_id)
                {
                    console.log("ScrollToEntryByID scrolling to entry ", element);
                    element.Close()
                }
            });
        },
        ConvertVueProxyToObject(proxy:any)
        {
            // console.log("ConvertVueProxyToObject:, starting with: ",proxy," ending with: ", toRaw(proxy));
            // return toRaw(proxy) as Entry;

            return new Entry(toRaw(proxy));
        },
        async DateStartChanged(date:Date)
        {
            console.log("date start changed", date);
            this.date_start=date;
            //need to update query for entries
 
            await this.DateChanged();
        },
        async DateEndChanged(date:Date)
        {
            console.log("date end changed", date);
            this.date_end=date;
            //need to update query for entries
            
            await this.DateChanged();
            
        },
        async DateChanged()
        {

            //if running by getting the date selected before grabbing the cats (so when get the date range set in user prefs), just skip, since it will be run in userset afterwards
            if(this.categories.length==0)
                return;

            await this.GetEntriesInCatsByDateRange(this.date_start, this.date_end);

            // let result = await this.GetEntriesByDateRange(this.date_start, this.date_end);

            // this.categories = [...this.categories];
            
            console.log("EntryList finished! this.categories: ", this.cats_w_entries);
            // this.$forceUpdate();
            // this.ForceUpdate();
        },
        
        GetDateEnd()
        {
            return this.date_start;
        },
        AddOneToStartDate()
        {
            //EOD Update: can change the parents rendering of start date now, but the datetime never gets the update...

            this.date_start.setFullYear(this.date_start.getFullYear()+1);//doesn't actually do anything on the front end  / won't update the date pickers
            console.log("changed date start year to: ", this.date_start.getFullYear());
            this.date_start = new Date(this.date_start);

            this.DateStartChanged(this.date_start);
        },

        //options: today, yesterday, last_7_days, last_30_days, all_time, custom
        async DateSelectChanged(value:any)
        {
            console.log("DateSelectChanged: ", value);

            //set the select box value to whatever was selected
            this.option_date_selected=value;
            UserPrefs.SavePref(UserPrefs.date_range_entries.name, value);

            if(value=="custom")
            {
                this.custom_date_range = true;
                //also need to fill in 
            }
            else
            {
                this.custom_date_range = false;
                if(value=="today")
                {
                    let date = new Date();
                    date.setHours(0,0,0);
                    this.date_start = date;

                    let date2 = new Date();
                    date2.setHours(23,59,59);
                    this.date_end = date2;
                    console.log("date start: ", date, "date end: ", date2);

                    await this.DateChanged();
                }
                else if(value=="yesterday")
                {
                    let date = new Date();
                    date.setDate(date.getDate()-1);
                    date.setHours(0,0,0);
                    this.date_start = date;

                    let date2 = new Date();
                    date2.setDate(date2.getDate()-1);
                    date2.setHours(23,59,59);
                    this.date_end = date2;
                    console.log("yesterday: date start: ", date, "date end: ", date2);

                    await this.DateChanged();
                }
                else if(value=="last_7_days")
                {
                    let date = new Date();
                    date.setDate(date.getDate()-7);
                    date.setHours(0,0,0);
                    this.date_start = date;

                    let date2 = new Date();
                    // date2.setDate(date2.getDate()-1);
                    date2.setHours(23,59,59);
                    this.date_end = date2;
                    console.log("last_7: date start: ", date, "date end: ", date2);

                    await this.DateChanged();
                }
                else if(value=="last_30_days")
                {
                    let date = new Date();
                    date.setDate(date.getDate()-30);
                    date.setHours(0,0,0);
                    this.date_start = date;

                    let date2 = new Date();
                    // date2.setDate(date2.getDate()-1);
                    date2.setHours(23,59,59);
                    this.date_end = date2;
                    console.log("last_7: date start: ", date, "date end: ", date2);

                    await this.DateChanged();
                }
                else if(value=="all_time")
                {
                    let date = new Date();
                    date.setFullYear(date.getFullYear()-1000);
                    date.setHours(0,0,0);
                    this.date_start = date;

                    let date2 = new Date();
                    date2.setFullYear(date2.getFullYear()+1000);
                    this.date_end = date2;
                    console.log("last_7: date start: ", date, "date end: ", date2);

                    await this.DateChanged();
                }
            }
        }, 
        EntrysWithDateHeader(entries:Array<Entry>)
        {
            let dates_with_entries = new Array();

            for (let i = 0; i < entries.length; i++) 
            {
                const entry = entries[i];
                
                //look through dates, if if it's already there, add it, if it is, add it to it
                let date_exists=-1;
                for (let i = 0; i < dates_with_entries.length; i++)
                {
                    if(this.DatesEqual(entry.date_updated, dates_with_entries[i].date))
                    {
                        date_exists=i;
                        break;
                    }
                }
                if(date_exists==-1)
                {
                    dates_with_entries.push({date:entry.date_updated, entries:[entry]});
                }
                else
                    dates_with_entries[date_exists].entries.push(entry);
            }

            return dates_with_entries;
        },
        DatesEqual(date1:Date, date2:Date)
        {
            return date1.getDate() == date2.getDate() && 
                    date1.getMonth() == date2.getMonth()&& 
                    date1.getFullYear() == date2.getFullYear();
        },
        //force it to update when thigns change- vue doesn't really seem to be capable of realizing when an array changes, but will actually check
        //if you put a fake key on the main div and change it
        async ForceUpdate()
        {
            
            //have to update this.categories
            await this.GetEntriesInCatsByDateRange(this.date_start, this.date_end);
            
            // await Data.GetCategories(this.user.id, true) as Array<CategoryData>;
            
            // console.log("EntryList, cats: ", cats);
            // let cats = await this.GetEntriesByDateRange(this.date_start, this.date_end);
            console.log("EntryList, cats after date range: ", this.cats_w_entries);
            
            //have to set this afterwards
            // this.categories = [...cats];

             //lets also add a "is_open prop for closing a cat
            


            // HACK to force it- since it's not aware of the entries inside of categories
            //from: https://stackoverflow.com/questions/32106155/can-you-force-vue-js-to-reload-re-render
            
            // await this.UserSet();
            this.key_to_force_update++;

            //doesn't work a lot of the time
            // this.$forceUpdate();
        },
        //for when a cat gets updated/ added through catedit- need to update the cats here, in the sub compnent entryel->entry editable
        async UpdateCatsAfterAddOrUpdate(cat_updated:CategoryData)
        {
            console.log("EntryList: Got UpdateCatsAfterAddOrUpdate, cat_updated: ", cat_updated);

            //forces a refrsh: 
            // this.UserSet();

            //ince we can't update individual items in the for loop, should save their state to re-open, and re-apply things- in the future

            //can't seem to update items in a for loop, no mater what I do- have to replace the whole array, but will refresh everything...

            //update the cats- but might caue ui to refresh....
            //it does update it- but updates all of them, not just the one that was changed
            // for (let i = 0; i < this.CatsThatHaveEntries.length; i++) 
            // {
            //     const cat = this.CatsThatHaveEntries[i];
            //     if(cat.id==cat_updated.id)
            //     {
            //         this.CatsThatHaveEntries[i] = new CategoryData({...cat_updated});
            //         console.log("changed out cats that have entries: ", this.CatsThatHaveEntries[i])
            //         //
            //         // this.CatsThatHaveEntries[i].name= "updated";
            //         let cat_ui = (this.$refs.cats as any)[i];
            //         console.log("updating just cat that changed: was: ", cat_ui);
            //         // cat_ui.$forceUpdate(); //cant do since it's a div
            //         cat_ui.key++;
            //         await this.$nextTick();
            //         cat_ui.key++;
                    
            //         //removes the category...
            //         // this.categories[i] = new CategoryData(this.categories[i]);
            //         // console.log("updating just cat that changed: now: ", this.categories[i]);
            //     }
                
            // }
            // this.UserSet();
        },
        EditCat(cat:CategoryData)
        {
            console.log("going to edit cat: ", cat);
            this.MoveForwardToPage(StaticVars.SCREENS.CAT_EDIT,{last_screen:StaticVars.SCREENS.ENTRY_INPUT, cat:cat})
        },
		GetEntriesBySearchInternal()
		{
			if(this.search_txt=="")
			{
				this.ShowModal({text:"cant search for a blank", only_one_btn:true});
				return;
			}
			console.log("search clicked (searchclicked function, ", this.search_txt);
			this.GetEntriesBySearch(this.search_txt);
		},

        // SetDateRangeSelected(value:string)
        // {
        //     UserPrefs.SavePref(UserPrefs.date_range_entries.name, value);
        // },


        

    },
    watch : 
    {
        date_start:function(date_start) 
        {
            console.log("watch date start called");
            this.date_start = date_start;
        },
        user:function(user) 
        {
            console.log("EntryList: watch user called-  also have to do this for categories", user);
            // this.UserSet();
        },
        categories:function(cats_new) 
        {
            console.log("EntryList: watch categories called, have to re-run setup, cats: ", this.categories, "old cats: ", this.cats_w_entries);
            this.SetupCats();
        },
        
    },
    computed:
    {
        GetDateStart()
        {
            return this.date_start;
        },
        //can't do a v-if for the variable being declare don the for loop, so have to use this hack instead:
        //can't do: <div v-for="cat, cat_index in categories" class="cat_area" v-if="cat.entries.length>0" >
        //https://stackoverflow.com/questions/48933606/v-for-and-v-if-not-working-together-in-vue-js
        CatsThatHaveEntries()
        {
            console.log("Cats that have entries", this.cats_w_entries);

            // this.DateChanged();//filter by date selected
            return this.cats_w_entries.filter(cat => cat.entries.length>0);
        },
        /* GetDateRangeSelected()
        {
            return UserPrefs.date_range_entries;
        }, */
        //for getting entries, that are organized under the same date heading- 
        //so should go through the entires, check date, see if any others with the same date, and add the date header + any other ones under the 
        
        /*
        If we refer to the data objects in the HTML area- 
        it doesn't actually grab them when they change. 
        It only gets their initial value, and doesn't update the UI, even when forced with the new value.

        So have to get their value through a "Getter", to actually get their value. Might have to put it in computed if it keeps trying to refuse to update UI
        */
        /* GetData(data_name:string, test:any)
        {
            //ts-ignore - hack to get typescript to allow us getting the property
            let obj:any = {...this.$data}
            console.log("GetData, obj: ", obj, "data name: ", data_name);
            console.log("GetData, value: ", obj[data_name]);
            return obj[data_name];
            // return this.date_start;
        } */
    },
    
});

</script>

<template >
    <div v-if="loaded" :key="key_to_force_update"><!-- Hack to get vue to actually show data that has been set in the parent 'mounted' component- since it's unaware of data changing-->
    <!-- <p>Loaded! {{ key_to_force_update }}</p> -->
        <!-- <button @click="AddOneToStartDate"> Click Me: {{ date_start }}</button> -->
    <div>
        
    </div>
    <div class="date_select">
        <div class="select_wrapper">
            <select @change="(e)=>{DateSelectChanged((e.target! as HTMLSelectElement).value)}" :value="option_date_selected">
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last_7_days">Last 7 days</option>
                <option value="last_30_days">Last 30 days</option>
                <option value="all_time">All Time</option>
                <option value="custom">Custom Date Range</option>
            </select>
        </div>
        <div v-if="option_date_selected=='custom'" class="date_range">
            <div>
                <p>Date start: <!-- {{date_start}} --></p>
                <!-- Hack to get it to actually get the updated-->
                <DatePicker :onDateChanged="DateStartChanged" :date_in="date_start"/>
            </div>
            <div>
                <p>Date End: <!-- {{date_end}} --></p>
                <DatePicker :onDateChanged="DateEndChanged"  :date_in="date_end"/>
            </div>
        </div>
        <div>
            <Button text="Reload" class="" :callback="ReloadPage" :wrap_txt="false"/>
			
        </div>
		<div>
			<input type="text" v-model="search_txt" style="max-width: 15ch;"/>
			<Button icon="search" :callback="GetEntriesBySearchInternal"/>
		</div>
    </div>
    <h1>
        Entries
    </h1>
    <!-- <div v-for="cat, cat_index in categories" class="cat_area" v-if="cat.entries.length>0" > -->
    <div v-for="cat, cat_index in CatsThatHaveEntries" :key="cat.id" class="cat_area" ref="cats">
        <!-- Should also be a button to edit this cat -->
        <Button :icon="cat.icon" :text="cat.name" :color_bg="cat.color_bg" :color_txt="cat.color_txt" 
        :border_radius="'10px 10px 0px 0px'" :class="'button_to_header'" 
        :fontweight="'normal'"
        :hover_effect_scale="false"
        :hover_effect_dim="true"
        :hold_for_callback="true"
        :hold_callback="()=>{EditCat(cat)}"
        :callback="()=>{(cat as any).is_open=!(cat as any).is_open;}"
        icon_dir="row"
        />
        <!-- <h2 class="cat_header" :style="{'background-color':cat.bg_color, 'color':cat.txt_color}"> <span class="material-symbols-outlined">{{cat.icon}}</span> {{cat.name}}</h2> -->
        <div class="container" :style="{'border-color':cat.color_bg}" v-show="(cat as any).is_open">
        <!-- <div>cat.entries.length: {{ cat.entries.length }}</div> -->
        <!-- <div v-for="entry, entry_index in cat.entries">
            {{entry}}
            <Button type="no" :callback="DeleteClicked" :extra_info="{entry_index: entry_index, cat_index:cat_index, entry_id:entry.id}" />
        </div> -->

        <!-- For some reason vue complains if we pass entry to entry as an entry.... Even if we cast it, or convert to raw, it sees it as not the same object, even with the same parameters... so have to create a new entry we pass to it... -->
        <!-- <EntryEl v-if="!dont_render_entries"  v-for="entry, entry_index in cat.entries" style="margin-top:10px;"

        
        :entry="(ConvertVueProxyToObject(entry) as Entry)"
        :extra_info="{entry_index: entry_index, cat_index:cat_index, entry_id:entry.id, entry:entry}"
        :DeleteClickedParent="DeleteClicked"
        :EntryEditedParent="EntryEdited"
        /> -->
        <div v-for="date in EntrysWithDateHeader(cat.entries)">

        <h3 style="color:white; font-weight: bold; margin-top:10px; border-bottom: 1px solid gray; margin-right:50px; padding-bottom:10px; margin-left:10px;">{{(date.date.toDateString())}}</h3>
        
        <div>
        <EntryEl v-if="!dont_render_entries"  v-for="entry, entry_index in date.entries" style="margin-top:10px;"

        
        :entry="(ConvertVueProxyToObject(entry) as Entry)"
        :extra_info="{entry_index: entry_index, cat_index:cat_index, entry_id:entry.id, entry:entry}"
        :DeleteEntryClicked="DeleteEntryClicked"
        :EntryEditedParent="EntryEdited"
        :ShowModal="ShowModal"
        :EntryOpened="EntryOpened"


        
        :BackButtonRegister="BackButtonRegister"
        :MoveForwardToPage="MoveForwardToPage"
        :MoveBack="MoveBack"


        :cats="categories"

        :GetPrevEntriesForCat="GetPrevEntriesForCat"
        :GetPrevAttributesForCat="GetPrevAttributesForCat"
        :AttributeCreateUpdateOrDelete="AttributeCreateUpdateOrDelete"
        :AddOrEditEntry="AddOrEditEntry"
        ref="entries"
        />
        <p v-else> Not rendering entries right now because changing the format</p>
        </div>
        </div>

    </div>

        
        
    </div>
</div>
    
</template>

<style scoped>

.date_select
{
    display: flex; 
    flex-direction: row; 
    gap: 5px 20px; 
    flex-wrap:wrap; 
    justify-content: center; 
    align-items: end;
}
.date_range
{
    display: flex; 
    flex-direction: row; 
    gap: 5px 20px; 
    flex-wrap:wrap; 
    justify-content: center; 
    align-items: end;
}

.cat_area
{
    /* border:1px solid grey; */
    
    margin-bottom:10px;
}
.cat_header
{
    padding:5px 20px;
    border-radius: 10px 10px 0px 0px;
}

/* To make a button look like the header */
.button_to_header
{
    width:100%;
    margin:0;
    text-align: left;
}
.container
{
    border:1px solid rgba(128, 128, 128); 
    border-top: 1px solid rgba(128, 128, 128, 0)
}
select
{
    font-size: 20px;
    background-color: var(--color-background-soft);
    color: var(--color-heading);
    padding: 5px;
    border: 1px solid var(--accent-color2);
    color-scheme: dark;
}

/* for date select areas, to keep it all on one line if possible */
@media only screen and (max-device-width: 653px)
{
   /*  .date_select
    {
        display:grid;
        grid-template-columns: repeat(2, 1fr);
        
    }
    .date_select>:nth-child(2)
    {
        text-align: right;
    }
    .date_select>:nth-child(3)
    {
        text-align: left;
    }
     .select_wrapper
    {
        grid-column-start: 1;
        grid-column-end: 3;
        text-align: center;;
        
    } */
    /* select
    {
        margin: 0 auto;
    } */
    /*
    select::after
    {
        content: '';
        flex-basis: 100%;
        height: 0;
    } */
}
@media only screen and (max-device-width: 418px)
{
    input[type="date"]
    {
        font-size:18px;
    }
    .date_range
    {
        gap: 5px 5px;
    }
}
@media only screen and (max-device-width: 368px)
{
    input[type="date"]
    {
        font-size:15px;
    }
    .date_range
    {
        gap: 2px 2px;
    }
}

</style>